import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ADD_TOKEN_INPUT: `${cleanedFilename(__filename)}-add-token-input`,
};
